import { store } from '@maui-mf/common-auth'

const loadPromise = store.initWithStorage().then(() => store)

export const ready = () => loadPromise
export const subscribe = fn => ready().then(store => store.subscribe(fn))
export const getValue = () => ready().then(store => store.getValue())
